<template>
  <div class="window-height">
    <picture class="background-image">
      <source srcset="@/assets/illustration.webp" type="image/webp" />
      <img src="@/assets/illustration.png" alt="banner image" />
    </picture>

    <div class="flex full-height items-center justify-center">
      <q-card>
        <q-card-section>
          <h6>Verify user</h6>
        </q-card-section>

        <q-card-section v-if="loading" class="flex justify-center">
          <q-spinner size="lg" color="primary" :thickness="3" />
        </q-card-section>

        <q-card-section v-if="error" class="flex column justify-center">
          <p class="text-weight-medium text-negative">{{ error }}</p>

          <q-btn class="q-mx-auto" label="Try again" unelevated color="primary" @click="debouncedVerify()" />
        </q-card-section>
      </q-card>
    </div>
  </div>
</template>

<script>
import _debounce from 'lodash/debounce';
import authApi from '@/apis/auth.api';
import { getErrorMessage } from '@/utils';

export default {
  props: {
    token: {
      type: String,
      required: true,
    },
  },

  data: () => ({
    loading: true,
    error: '',
  }),

  created() {
    this.debouncedVerify = _debounce(this.verify, 300);
    this.verify();
  },

  methods: {
    async verify() {
      this.loading = true;

      try {
        await authApi.verifyUser(this.token);
        await this.$router.replace('/');

        this.$q.notify({
          message: 'Verify successful',
          type: 'positive',
        });
      } catch (error) {
        this.loading = false;
        this.error = getErrorMessage(error);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.background-image {
  position: fixed;
  width: 100%;
  height: 100%;
  left: 0;
  right: 0;
  filter: blur(3px);

  img {
    width: 100%;
    height: 100%;
  }
}
</style>
